function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.221.653l15.185 8.832c1.605.871 2.346 2.364 2.346 4.105v17.54c0 1.866-.741 3.235-2.346 4.105l-15.061 8.832c-1.358.871-3.21.871-4.815 0L2.346 35.36C.988 34.489 0 32.996 0 31.255V13.59c0-1.866.864-3.234 2.346-4.105L17.406.653c1.606-.87 3.457-.87 4.815 0z",
  fill: "#1976D2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.655 34.266a.787.787 0 01-1.217.663l-6.87-4.509c-.379-.287-.884-1.147-.884-1.721v-5.587c0-.269.135-.52.36-.665l3.642-2.363a.783.783 0 01.844-.005l3.756 2.369c.23.145.369.398.369.67v11.148zM26.85 34.265a.787.787 0 001.217.663l6.87-4.515c.378-.287.884-1.15.884-1.724V17.526a.793.793 0 00-.36-.666l-3.642-2.365a.783.783 0 00-.845-.006l-3.756 2.373a.793.793 0 00-.368.67v16.733zM15.266 9.18v27.317c0 .271.137.523.364.668l3.699 2.367a.783.783 0 00.845 0l3.698-2.367a.793.793 0 00.365-.668V9.18a.793.793 0 00-.365-.668l-3.698-2.367a.783.783 0 00-.845 0L15.63 8.512a.793.793 0 00-.364.668z",
  fill: "#fff"
});

function SvgResidentLogoBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgResidentLogoBlue;